import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = {
  class: "d-flex w-100 justify-content-between"
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_th = _resolveComponent("b-th");
  const _component_b_tr = _resolveComponent("b-tr");
  const _component_wrap_with_popover = _resolveComponent("wrap-with-popover");
  const _component_flex_row = _resolveComponent("flex-row");
  const _component_evolution_type_switcher = _resolveComponent("evolution-type-switcher");
  const _component_AppIcon = _resolveComponent("AppIcon");
  const _component_hug_value = _resolveComponent("hug-value");
  const _component_date_value = _resolveComponent("date-value");
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_percentage_value = _resolveComponent("percentage-value");
  const _component_evolution_value = _resolveComponent("evolution-value");
  const _component_rate_change_value = _resolveComponent("rate-change-value");
  const _component_number_value = _resolveComponent("number-value");
  const _component_bar_with_value = _resolveComponent("bar-with-value");
  const _component_slot_with_evolution_value = _resolveComponent("slot-with-evolution-value");
  const _component_boxed_value = _resolveComponent("boxed-value");
  const _component_dotted_value = _resolveComponent("dotted-value");
  const _component_overlap_bar_value = _resolveComponent("overlap-bar-value");
  const _component_b_table_lite = _resolveComponent("b-table-lite");
  const _component_wrap_table_with_show_more = _resolveComponent("wrap-table-with-show-more");
  const _component_line_chart = _resolveComponent("line-chart");
  const _component_bar_chart = _resolveComponent("bar-chart");
  const _component_bar_line_chart = _resolveComponent("bar-line-chart");
  const _component_evolution_chart_modal = _resolveComponent("evolution-chart-modal");
  const _component_table_with_title = _resolveComponent("table-with-title");
  return _openBlock(), _createBlock(_component_table_with_title, {
    title: "Evolution",
    class: "performance-period-table",
    onDownload: $options.downloadPerformancePeriodCSV,
    onCopy: $options.copyPerformancePeriodCSV,
    onGoogleSheetDownload: $options.downloadPerformanceGoogleSheet,
    fields: $data.fields,
    loading: $props.loading,
    onChartModalOpen: _cache[4] || (_cache[4] = $event => $data.chartModal = true)
  }, {
    "period-selector": _withCtx(() => [_renderSlot(_ctx.$slots, "period-selector")]),
    "chart-modal": _withCtx(() => [$data.chartEngine ? (_openBlock(), _createBlock(_component_evolution_chart_modal, {
      key: 0,
      modelValue: $data.chartModal,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.chartModal = $event),
      options: _ctx.TABBED_FIELDS,
      items: $options.items,
      onModalShown: $options.onChartModalShown,
      chartEngine: $data.chartEngine,
      onRechart: _cache[2] || (_cache[2] = keys => $options.handleRechart(keys)),
      periodEndOf: $data.APP_PERIOD_DROPDOWN_ELEMENTS?.[_ctx.period?.toUpperCase()]?.endOf,
      onRefreshChart: $options.refreshChart,
      onResize: _cache[3] || (_cache[3] = ({
        width,
        height
      }) => $options.resizeChart(width, height))
    }, {
      "line-chart": _withCtx(({
        x2Label,
        metricColor,
        showEvolution
      }) => [_createVNode(_component_line_chart, {
        ref: "chart",
        data: $options.chartConfig?.data,
        options: $options.chartConfig?.options,
        x2Label: x2Label,
        showEvolution: showEvolution,
        "metric-color": metricColor
      }, null, 8, ["data", "options", "x2Label", "showEvolution", "metric-color"])]),
      "bar-chart": _withCtx(({
        x2Label,
        metricColor,
        showEvolution
      }) => [_createVNode(_component_bar_chart, {
        ref: "chart",
        data: $options.chartConfig?.data,
        options: $options.chartConfig?.options,
        showEvolution: showEvolution,
        "metric-color": metricColor,
        x2Label: x2Label
      }, null, 8, ["data", "options", "showEvolution", "metric-color", "x2Label"])]),
      "bar-line-chart": _withCtx(({
        x2Label,
        metricColor,
        showEvolution
      }) => [_createVNode(_component_bar_line_chart, {
        ref: "chart",
        data: $options.chartConfig?.data,
        options: $options.chartConfig?.options,
        showEvolution: showEvolution,
        "metric-color": metricColor,
        x2Label: x2Label
      }, null, 8, ["data", "options", "showEvolution", "metric-color", "x2Label"])]),
      _: 1
    }, 8, ["modelValue", "options", "items", "onModalShown", "chartEngine", "periodEndOf", "onRefreshChart"])) : _createCommentVNode("", true)]),
    default: _withCtx(() => [_createVNode(_component_wrap_table_with_show_more, {
      modelValue: $options.period_pager,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.period_pager = $event),
      period: _ctx.period
    }, {
      default: _withCtx(() => [_createVNode(_component_b_table_lite, {
        class: "lite-table lite-table-hoverable period-table performance-table",
        fields: $data.fields,
        bordered: "",
        responsive: "",
        fixed: "",
        items: $options.items,
        "sticky-header": true,
        tbodyTrClass: item => _ctx.handleRowClass(item, $options.items),
        "no-border-collapse": "",
        onRowClicked: $options.handleRowClick
      }, {
        "thead-top": _withCtx(() => [_createVNode(_component_b_tr, {
          class: "headers"
        }, {
          default: _withCtx(() => [_createVNode(_component_b_th, {
            colspan: "2"
          }), _createVNode(_component_b_th, {
            colspan: "3",
            class: "performance",
            style: _normalizeStyle({
              color: 'var(--market-800)',
              borderBottom: '1px solid var(--market-800)'
            })
          }, {
            default: _withCtx(() => [_createTextVNode("Performance")]),
            _: 1
          }, 8, ["style"]), _createVNode(_component_b_th, {
            colspan: "2",
            class: "supply",
            style: {
              color: '#9447FF',
              borderBottom: '1px solid #9447FF'
            }
          }, {
            default: _withCtx(() => [_createTextVNode("Supply")]),
            _: 1
          }), _createVNode(_component_b_th, {
            colspan: "3",
            class: "listing",
            style: {
              color: '#4C8EFF',
              borderBottom: '1px solid #4C8EFF'
            }
          }, {
            default: _withCtx(() => [_createTextVNode("Listing")]),
            _: 1
          }), _createVNode(_component_b_th, {
            colspan: "2",
            class: "advertising",
            style: {
              color: '#068481',
              borderBottom: '1px solid #068481'
            }
          }, {
            default: _withCtx(() => [_createTextVNode("Advertising")]),
            _: 1
          })]),
          _: 1
        })]),
        "head()": _withCtx(col => [_createVNode(_component_flex_row, {
          id: `performance-period-table-${col?.label}`,
          styles: {
            justifyContent: col.field.justify,
            ...col.field.thStyle
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_wrap_with_popover, {
            target: `performance-period-table-${col?.label}`
          }, {
            title: _withCtx(() => [_createElementVNode("div", {
              innerHTML: $options.getDescriptionBasedOnKpiKey(col?.column).title
            }, null, 8, _hoisted_1)]),
            content: _withCtx(() => [_createTextVNode(_toDisplayString($options.getDescriptionBasedOnKpiKey(col?.column).detail), 1)]),
            default: _withCtx(() => [_createElementVNode("div", {
              innerHTML: col?.column === 'period_agg' ? $options.getPeriodColumnTitle : col?.label,
              class: "title"
            }, null, 8, _hoisted_2)]),
            _: 2
          }, 1032, ["target"])]),
          _: 2
        }, 1032, ["id", "styles"])]),
        "head(revenue_excl_VAT)": _withCtx(col => [_createVNode(_component_flex_row, {
          styles: {
            justifyContent: col.field.justify,
            ...col.field.thStyle
          }
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_wrap_with_popover, {
            triggers: "hover",
            target: 'performance-period-table-revenue_excl_VAT',
            style: {
              width: 'fit-content'
            }
          }, {
            title: _withCtx(() => [_createElementVNode("div", {
              innerHTML: $options.getDescriptionBasedOnKpiKey(col?.column).title
            }, null, 8, _hoisted_4)]),
            content: _withCtx(() => [_createTextVNode(_toDisplayString($options.getDescriptionBasedOnKpiKey(col?.column).detail), 1)]),
            default: _withCtx(() => [_createElementVNode("div", {
              id: 'performance-period-table-revenue_excl_VAT',
              class: "title",
              innerHTML: col?.label
            }, null, 8, _hoisted_5)]),
            _: 2
          }, 1024), _createVNode(_component_wrap_with_popover, null, {
            title: _withCtx(() => [_createElementVNode("div", {
              innerHTML: $options.getDescriptionBasedOnKpiKey('evolution_type_button').title
            }, null, 8, _hoisted_6)]),
            content: _withCtx(() => [_createTextVNode(_toDisplayString($options.getDescriptionBasedOnKpiKey('evolution_type_button').detail), 1)]),
            default: _withCtx(() => [_createVNode(_component_evolution_type_switcher, {
              onClick: $options.switchEvolutionType,
              evolutionType: _ctx.evolutionType
            }, null, 8, ["onClick", "evolutionType"])]),
            _: 1
          })])]),
          _: 2
        }, 1032, ["styles"])]),
        "cell(selector)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_AppIcon, {
            icon: `zoom-${row.item.selected ? 'out' : 'in'}`,
            color: row.item.selected ? null : '#ADADAD',
            size: 16
          }, null, 8, ["icon", "color"])]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(period_agg)": _withCtx(row => [_createVNode(_component_date_value, {
          value: row.item?.period_agg,
          format: $options.getDateValueFormat,
          styles: {
            justifyContent: 'flex-start',
            ..._ctx.activateDateValueStyles(row)
          },
          loading: $props.loading
        }, null, 8, ["value", "format", "styles", "loading"])]),
        "cell(revenue_excl_VAT)": _withCtx(row => [_createVNode(_component_rate_change_value, {
          value1: row.item?.revenue_and_lost_revenue_excl_VAT,
          onClick: $event => $options.handleRowClick(row.item),
          value2: row.item?.revenue_excl_VAT,
          min1: 0,
          min2: 0,
          max1: $options.minMax?.revenue_and_lost_revenue_excl_VAT?.max,
          max2: $options.minMax?.revenue_and_lost_revenue_excl_VAT?.max,
          loading: $props.loading,
          rateChange: _ctx.periodCategory === 'prev_period' ? row.item?.revenue_excl_VAT_evol : row.item?.last_year_revenue_excl_VAT_evol,
          color1: "#FFB3B8",
          color2: "var(--market-400)",
          evolutionType: _ctx.evolutionType
        }, {
          lost: _withCtx(() => [_createVNode(_component_currency_value, {
            value: row.item?.lost_revenue_excl_VAT,
            limit: 10_000,
            loading: $props.loading,
            styles: {
              justifyContent: 'flex-end',
              width: '100%'
            }
          }, null, 8, ["value", "loading"])]),
          gained: _withCtx(() => [_createVNode(_component_currency_value, {
            value: row.item?.revenue_excl_VAT,
            limit: 10_000,
            loading: $props.loading
          }, null, 8, ["value", "loading"])]),
          evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
            value: row.item?.[`${_ctx.evolCategory[_ctx.periodCategory]}revenue_excl_VAT_evol${_ctx.evolutionTypeKpi[_ctx.evolutionType]}`]
          }, {
            default: _withCtx(({
              color
            }) => [_ctx.evolutionType === 'currency' ? (_openBlock(), _createBlock(_component_currency_value, {
              key: 0,
              value: row.item?.[`${_ctx.evolCategory[_ctx.periodCategory]}revenue_excl_VAT_evol${_ctx.evolutionTypeKpi[_ctx.evolutionType]}`],
              color: color,
              charCount: $options.maxCharCount.currency?.[`${_ctx.evolCategory[_ctx.periodCategory]}revenue_excl_VAT_evol${_ctx.evolutionTypeKpi[_ctx.evolutionType]}`],
              "show-sign": ""
            }, null, 8, ["value", "color", "charCount"])) : _createCommentVNode("", true), _ctx.evolutionType === 'percentage' ? (_openBlock(), _createBlock(_component_percentage_value, {
              key: 1,
              "show-sign": "",
              value: row.item?.[`${_ctx.evolCategory[_ctx.periodCategory]}revenue_excl_VAT_evol${_ctx.evolutionTypeKpi[_ctx.evolutionType]}`],
              color: color,
              charCount: $options.maxCharCount.percentage?.[`${_ctx.evolCategory[_ctx.periodCategory]}revenue_excl_VAT_evol${_ctx.evolutionTypeKpi[_ctx.evolutionType]}`]
            }, null, 8, ["value", "color", "charCount"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["value"])]),
          default: _withCtx(() => [_createVNode(_component_currency_value, {
            value: row.item?.revenue_excl_VAT,
            limit: 10_000,
            loading: $props.loading,
            charCount: $options.maxCharCount?.currency?.revenue_excl_VAT
          }, null, 8, ["value", "loading", "charCount"])]),
          _: 2
        }, 1032, ["value1", "onClick", "value2", "max1", "max2", "loading", "rateChange", "evolutionType"])]),
        "cell(days_inventory)": _withCtx(row => [_createVNode(_component_bar_with_value, {
          value: row.item?.days_inventory,
          min: $options.minMax?.days_inventory?.min,
          color: "#CC9F6C",
          max: $options.minMax?.days_inventory?.max,
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_number_value, {
            value: row.item?.days_inventory,
            styles: {
              padding: 0
            }
          }, null, 8, ["value"])]),
          _: 2
        }, 1032, ["value", "min", "max", "loading"])]),
        "cell(page_views)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 4
          }, {
            evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`${_ctx.evolCategory[_ctx.periodCategory]}page_views_evol`]
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`${_ctx.evolCategory[_ctx.periodCategory]}page_views_evol`],
                color: color,
                "show-sign": "",
                charCount: $options.maxCharCount.percentage?.[`${_ctx.evolCategory[_ctx.periodCategory]}page_views_evol`]
              }, null, 8, ["value", "color", "charCount"])]),
              _: 2
            }, 1032, ["value"])]),
            default: _withCtx(() => [_createVNode(_component_bar_with_value, {
              tight: "",
              align: "left",
              value: row.item?.page_views,
              min: $options.minMax?.page_views?.min,
              color: "#8D85E5",
              max: $options.minMax?.page_views?.max,
              loading: $props.loading
            }, {
              default: _withCtx(() => [_createVNode(_component_number_value, {
                value: row.item?.page_views,
                charCount: $options.maxCharCount?.number?.page_views,
                tight: ""
              }, null, 8, ["value", "charCount"])]),
              _: 2
            }, 1032, ["value", "min", "max", "loading"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(organic_CVR)": _withCtx(row => [_createVNode(_component_boxed_value, {
          bgColor: $options.getColorsBasedOnRange(row.item?.organic_CVR, $data.ORGANIC_CVR_HEATMAP_COLORS),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_percentage_value, {
            value: row.item?.organic_CVR,
            precision: 1
          }, null, 8, ["value"])]),
          _: 2
        }, 1032, ["bgColor", "loading"])]),
        "cell(traffic_by_asin_buy_box_percentage)": _withCtx(row => [_createVNode(_component_dotted_value, {
          align: 'center',
          color: $options.getColorsBasedOnRange(row.item?.traffic_by_asin_buy_box_percentage, $data.BUYBOX_HEATMAP_COLORS),
          value: row.item?.traffic_by_asin_buy_box_percentage,
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_percentage_value, {
            value: row.item?.traffic_by_asin_buy_box_percentage
          }, null, 8, ["value"])]),
          _: 2
        }, 1032, ["color", "value", "loading"])]),
        "cell(share_sponsored_sales)": _withCtx(row => [_createVNode(_component_bar_with_value, {
          value: row.item?.share_sponsored_sales,
          min: $options.minMax?.share_sponsored_sales?.min,
          color: "#4C8EFF",
          max: $options.minMax?.share_sponsored_sales?.max,
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_percentage_value, {
            value: row.item?.share_sponsored_sales,
            charCount: $options.maxCharCount.percentage?.share_sponsored_sales
          }, null, 8, ["value", "charCount"])]),
          _: 2
        }, 1032, ["value", "min", "max", "loading"])]),
        "cell(TACOS)": _withCtx(row => [_createVNode(_component_overlap_bar_value, {
          value: row.item?.TACOS,
          background: "#EBD4F7",
          borderColor: "#CD93EB",
          min: $options.minMax?.TACOS?.min,
          max: $options.minMax?.TACOS?.max,
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_percentage_value, {
            value: row.item?.TACOS
          }, null, 8, ["value"])]),
          _: 2
        }, 1032, ["value", "min", "max", "loading"])]),
        "cell(total_quantity)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 16
          }, {
            evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`${_ctx.evolCategory[_ctx.periodCategory]}total_quantity_evol`]
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`${_ctx.evolCategory[_ctx.periodCategory]}total_quantity_evol`],
                color: color,
                "show-sign": "",
                charCount: $options.maxCharCount.percentage?.[`${_ctx.evolCategory[_ctx.periodCategory]}total_quantity_evol`]
              }, null, 8, ["value", "color", "charCount"])]),
              _: 2
            }, 1032, ["value"])]),
            default: _withCtx(() => [_createVNode(_component_number_value, {
              value: row.item?.total_quantity,
              loading: $props.loading,
              tight: ""
            }, null, 8, ["value", "loading"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(lost_revenue_excl_VAT)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          align: "right"
        }, {
          default: _withCtx(() => [_createVNode(_component_currency_value, {
            value: row.item?.lost_revenue_excl_VAT,
            color: $data.COLORS.RED700
          }, null, 8, ["value", "color"])]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(avg_unit_price)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 16
          }, {
            evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`${_ctx.evolCategory[_ctx.periodCategory]}avg_unit_price_evol`]
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                "show-sign": "",
                value: row.item?.[`${_ctx.evolCategory[_ctx.periodCategory]}avg_unit_price_evol`],
                color: color,
                charCount: $options.maxCharCount.percentage?.[`${_ctx.evolCategory[_ctx.periodCategory]}avg_unit_price_evol`]
              }, null, 8, ["value", "color", "charCount"])]),
              _: 2
            }, 1032, ["value"])]),
            default: _withCtx(() => [_createVNode(_component_currency_value, {
              value: row.item?.avg_unit_price,
              precision: 2,
              align: "right"
            }, null, 8, ["value"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        _: 1
      }, 8, ["fields", "items", "tbodyTrClass", "onRowClicked"])]),
      _: 1
    }, 8, ["modelValue", "period"])]),
    _: 3
  }, 8, ["onDownload", "onCopy", "onGoogleSheetDownload", "fields", "loading"]);
}